import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationTaskModalComponent } from './confirmation-task-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationTaskModalService {

  constructor(public dialogService: DialogService) { }

  openModal() {
    this.dialogService.open(ConfirmationTaskModalComponent, {
      width: '520px',
      height: '460px',
      // contentStyle: { 'border-radius': '6px' },
      baseZIndex: 10000,
      dismissableMask: false,
      styleClass: 'dialogComponent dialog-header-disabled' ,
      data: []
    });
  }
}
